export const DEVICE_FILE_TYPE_NAME_MAP = {
  'project-documentation': 'Projektová dokumentácia',
  revision: 'Revízne správy',
  'signed-document': 'Podpísané dokumenty',
  'form-service-report': 'Servisná správa',
  'form-service-report-supplier': 'Servisná správa - Poskytovateľ č.2',
  photos: 'Fotografie',
  other: 'Ostatné',
  department: 'Ostatná dokumentácia z položky úrovne',
} as const;

export type DeviceFileType = keyof typeof DEVICE_FILE_TYPE_NAME_MAP;

export const DEVICE_FILE_TYPE_ACCESS_PERMISSION_MAP: Record<DeviceFileType, string> = {
  'project-documentation': 'access-files-project-documentation',
  revision: 'access-files-revision',
  'signed-document': 'access-files-signed-document',
  'form-service-report': 'access-files-form-service-report',
  'form-service-report-supplier': 'access-files-form-service-report-supplier',
  photos: 'access-files-photos',
  other: 'access-files-other',
  department: 'access-files-department',
};

/** Returns the permission slug required to access the given file type. */
export function getDeviceFileTypeAccessPermission(fileType: DeviceFileType): string {
  return DEVICE_FILE_TYPE_ACCESS_PERMISSION_MAP[fileType];
}

/** Virtual tab value that groups all form-* file types under one tab. */
export const DEVICE_FILE_FORMS_TAB = 'forms' as const;

/** Union of real file types and the virtual forms group tab. */
export type DeviceFileTabValue = DeviceFileType | typeof DEVICE_FILE_FORMS_TAB;

/** Returns true if the given type belongs to the forms group. */
export function isFormFileType(type: DeviceFileType): boolean {
  return type.startsWith('form-');
}

/** Returns true if the given type belongs to the revision reports group. */
export function isRevisionFileType(type: DeviceFileType): boolean {
  return type === 'revision' || type === 'signed-document';
}

/** Returns true if users may upload a new file of the given type. */
export function isUploadableDeviceFileType(type: DeviceFileType): boolean {
  return type !== 'signed-document';
}
